import gql from 'graphql-tag';

export const GET_INITIAL_TABLE_DATA_QUERY = gql`
  query GetInitialTableData($getTableDataInput: GetTableDataInput!) {
    getTableData(getTableDataInput: $getTableDataInput) {
      id
      columns {
        id
        name
        type
        typeOptions
      }
      rows {
        id
        cells
      }
      views {
        id
        type
        name
        parentRow
        stackedBy
        columns {
          id
          order
          width
          isHidden
          isHiddenInKanban
        }
        rows {
          id
          order
        }
        controls
      }
    }
  }
`;
